
<div class="t-popup popup-patientDetails">

    <div class="t-popup-close"></div>

    <div class="t-popup-frame">
        <div class="t-popup-body" [formGroup]="searchForm">

            <button class="t-btn-popup-close" aria-label="close popup" (click)="close()"></button>

            <h2>

            </h2>

           
           

          
            <div  style="display: flex; justify-content: center;
            align-items: center;
            gap: 1em;
            margin-top: 2em;">
                <button  class="confirm--btn" (click)="searchSlots()" >
                    {{'appointments.gui.buttons.search appts' | translate}}
                </button>
                <div class="l-flex l-flex-c t-field t-field-pad rtl" style="height: 2.5em;">
                    <label class="w50" style="white-space: nowrap;">   {{ 'appointments.gui.labels.Exam Type' | translate}}</label>
                    <select class="t-select w100"  formControlName="examType" >
                        <option *ngFor="let exam of getExamTypes()" [value]="exam.AutoIndex">
                            {{ getExamName(exam) }}
                          </option>
                     </select>
                    </div>
                </div>
                <div style="text-align: center;" *ngIf="loadingSlots" >
                    <img src="../../assets/images/Wedges.svg"/>
                </div>


                <div 
                class="l-flex patient-item-n" 
                *ngFor="let slot of slots; index as i"
                [ngStyle]="{'border-color': slot.only ? 'red' : 'green', 'border-width': '2px', 'border-style': 'solid'}">
            
                <button class="w100" style="cursor:pointer;" (click)="close(slot)">
            
                    <div class="l-table h100">
                        <span class="l-td-m patient-item-cell" style="width: 5em;">
                            <strong>{{i+1}}</strong>
                        </span>
                        <span class="l-td-m patient-item-cell">
                            <strong>{{ 'appointments.gui.labels.date' | translate }} :</strong> {{ slot.start | date:'dd-MM-yyyy HH:mm' }}
                        </span>
                        <span class="l-td-m patient-item-cell">
                            <strong>{{ 'appointments.gui.labels.Duration' | translate }}:</strong>
                            {{slot.duration}} {{ 'appointments.gui.labels.minutes' | translate }}
                        </span>
                        <span class="l-td-m patient-item-cell">
                            <strong>{{ 'appointments.gui.labels.room' | translate }}:</strong>
                            {{slot.RoomName}}
                        </span>
                    </div>
            
                </button>
            
            </div>
            
        </div>



    </div>
</div>
